import React, { useState, useEffect } from "react";
import {
    Col,
    Row,
    Card,
    CardBody,
    Modal,
    ModalBody,
    ModalHeader,
    List,
    CardText, Spinner
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Website/AuthService";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "store/Auth/actions"
import { useTranslation } from 'react-i18next';

const CallModal = ({ modal, setModal, callTypeModal, phone}) => {
    const { t } = useTranslation();
    const AuthData = useSelector(state => state.Auth);
     
    return (
        <Modal
            isOpen={modal}
            toggle={() => setModal(false)}
            style={{ maxWidth: '600px', marginTop: "10%", width: '100%'  }}
            className={`${AuthData.lang !== "ar" ? "":"ar-wrapper" }`}
        >
            <ModalBody className="m-0 p-0 fw-bold">
                <Card className='overflow-hidden m-0 p-0' style={{direction:"inherit"}}>
                    <CardBody className=' p-0 m-0'>
                      <Row className="m-4 fw-bold font-size-16" >

                          {callTypeModal=='compound' ? t("Available contact Number for this Compound") : t("Available contact Number for this Unit") }
                      </Row>
                      <Row className="m-4 fw-bold font-size-16">
                          {phone}
                      </Row>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    )
}
export default CallModal